export default "__VITE_ASSET__CqOgDZoh__"